import api from '@/security/api'
import errorCatch from '@/helpers/errorCatch'

export default (data) => {
    return api.post('/password/reset', data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível atualizar a senha')
        })
}
